import React from 'react';

const WikiHomePage = () => (
  <div className="gh-box">
    <div className="gh-box-header">
      <i className="bi bi-journal-text me-2" aria-hidden="true"></i>
      Welcome to Kira Wiki
    </div>
    <div className="gh-box-body wiki-markdown">
      <p>
        Kira Wiki is the internal knowledge-sharing site for the team. Use it to find and keep
        documentation, guides, and notes in one place.
      </p>

      <h2>How to browse</h2>
      <p>
        Select a page from the page list in the left sidebar to view its content. Pages can be
        organized into a parent and child structure (up to two levels), and child pages appear
        nested under their parent.
      </p>
      <ul>
        <li>Pages in the sidebar can be reordered by dragging them with the grip handle.</li>
        <li>The order you set is saved automatically and stays the same after reloading the page.</li>
      </ul>

      <h2>Editing pages</h2>
      <p>
        Open an existing page and use the <strong>Edit</strong> button to update its title, parent,
        or content. To create a new page, use the <strong>+</strong> button at the top of the
        sidebar.
      </p>

      <h2>Writing content</h2>
      <p>
        Page content is written in Markdown. Headings, lists, links, inline <code>code</code>, and
        code blocks are all supported and rendered in the page view.
      </p>
    </div>
  </div>
);

export default WikiHomePage;
